export const PATH_PAYMENT_ADD_PAYMENT_METHOD = "/payment/add-payment-method";
